import React, { useState, useEffect, useContext } from "react";
import {
  Label,
  Form,
  FormGroup,
  Row,
  Col,
  Input,
  InputGroup,
} from "reactstrap";
import { useController, useForm } from "react-hook-form";
import AsyncSelect from "react-select/async";
import Select from "react-select";
import { Button } from "@mui/material";
import AddBoxIcon from "@mui/icons-material/AddBox";
import SharedDataContext from "../../../_helper/SharedData";
import DatePicker from "react-datepicker";
import {
  getWalletAll,
  updateWallet,
  createWallet,
  getWalletAllSearch,
} from "../../../Services/Driver.service";
import { showAlert } from "../../../Services/Shared.service";
// import moment from "moment";

function WalletMinBal({
  driverScheme,
  isSearch,
  setIsSearch,
  triggerRefresh,
  handleBack,
  selectedServiceCityId,
}) {
  const {
    register,
    control,
    handleSubmit,
    formState: { errors },
    setValue,
    getValues,
    reset,
    watch,
  } = useForm({
    defaultValues: {},
  });
  const { minBalance, applicableFromDate, applicableToDate, applicableTo } =
    watch();
  const [edit, setEdit] = useState(false);
  const [walletMinList, setwalletMinList] = useState([]);
  const [selectedWallet, setSelectedWallet] = useState();
  const [driverTypeList, setDriverList] = useState([]);
  const [selectedDriverType, setSelectedDriverType] = useState();
  const { cityData, setTabValue } = useContext(SharedDataContext);

  const resolvedServiceCityId = driverScheme?.serviceCityId ?? selectedServiceCityId ?? null;
  const hasResolvedServiceCity = resolvedServiceCityId != null;
  const resolvedServiceCityOption = hasResolvedServiceCity
    ? cityData.find((element) => element.id === resolvedServiceCityId)
    : null;

  useEffect(() => {
    fetchwalletMinBal(driverScheme?.id, resolvedServiceCityId);
  }, []);

  const fetchwalletMinBal = (driverSchemeId, serviceCityId) => {
    const obj = {
      driverSchemeId: driverSchemeId,
      serviceCityId: serviceCityId,
    };
    getWalletAll(obj).then((resp) => {
      if (resp.status == 200) {
        const data = [];
        resp.data.searchResponse.forEach((element) => {
          data.push({
            label: "Value :" + element.minimumBalance,
            value: element,
            id: element?.id,
          });
        });
        setwalletMinList(data);
      }
    });
  };
  // console.log("Driver")

  // const getMinWalletOpt = async(inputValue)=>{
  //   let obj = {
  //     serviceCityId:driverScheme?driverScheme.serviceCityId:0,
  //     key:inputValue
  //   }

  //   if (inputValue.length) {
  //     return getWalletAllSearch(obj).then((result) => {
  //       const mappedArray = result.data.searchResponse.map((item) => ({
  //         value: item,
  //         label: item.driverSchemeName,
  //       }));

  //       return mappedArray;
  //     });
  //   }

  // }

  const { ServiceCity, DriverType } = watch();
  // const [isSearch, setIsSearch] = useState(false);

  const applicableToDateField = useController({
    name: "applicableToDate",
    control,
    rules: {
      required: {
        value: true,
        message: "Applicable To Date is Required",
      },
    },
  }).field;

  const handleApplicableToDate = (data) => {
    console.log("handleApplicableToDate", data);
    applicableToDateField.onChange(data);
  };

  const applicableFromDateField = useController({
    name: "applicableFromDate",
    control,
    rules: {
      required: {
        value: true,
        message: "Applicable From Date is Required",
      },
    },
  }).field;

  const handleApplicableFromDate = (data) => {
    applicableFromDateField.onChange(data);
  };

  const handleNewClick = () => {
    setIsSearch(false);
    setEdit(false);
    reset({
      DriverType: driverScheme?.name,
      ServiceCity: resolvedServiceCityOption ?? null,
    });
    console.log("Driver shceme", getValues("DriverType"));
  };

  const handleExistClick = (walletMinBalance) => {
    console.log("walletMinBalance", walletMinBalance);
    setEdit(true);
    setIsSearch(false);
    setSelectedWallet(walletMinBalance.value);
    reset({
      // DriverType:walletMinBalance.driverSchemeName?walletMinBalance.driverSchemeName:"",
      minBalance: walletMinBalance?.minimumBalance,
      ServiceCity: selectedWallet?.serviceCityId
        ? cityData.find(
            (element) => element?.id === selectedWallet?.serviceCityId
          )
        : { label: "Select Service City", value: "" },
      applicableFromDate: walletMinBalance?.applicableFrom
        ? new Date(walletMinBalance?.applicableFrom)
        : "",
      applicableToDate: walletMinBalance?.applicableTo
        ? new Date(walletMinBalance?.applicableTo)
        : "",
    });
    // setValue("applicableFromDate",selectedWallet?.applicableFromDate ? new Date(selectedWallet.applicableFromDate) : "",)
  };

  useEffect(() => {
    reset({
      // DriverType:walletMinBalance.driverSchemeName?walletMinBalance.driverSchemeName:"",
      minBalance: selectedWallet?.minimumBalance,
      ServiceCity: selectedWallet?.serviceCityId
        ? cityData.find(
            (element) => element.id === selectedWallet?.serviceCityId
          )
        : { label: "Select Service City", value: "" },
      // applicableFromDate: selectedWallet?.applicableFromDate ? new Date(selectedWallet.applicableFromDate) : "",
      applicableFromDate: selectedWallet?.applicableFrom
        ? new Date(selectedWallet?.applicableFrom)
        : "",
      applicableToDate: selectedWallet?.applicableTo
        ? new Date(selectedWallet?.applicableTo)
        : "",
    });
  }, [selectedWallet]);

  console.log("applicableFromDate", applicableFromDate);
  
  const handleWalletMinBalSubmit = (formValues) => {
    const body = {
      driverTypeId: driverScheme?.id,
      serviceCityId: formValues.ServiceCity ? formValues.ServiceCity?.id : null,
      minimumBalance: formValues.minBalance ? formValues.minBalance : "",
      applicableFrom: new Date(formValues.applicableFromDate),
      applicableTo: new Date(formValues.applicableToDate),
      createdOn:selectedWallet?.createdOn ?selectedWallet?.createdOn:null,
      createdById:selectedWallet?.createdById ?selectedWallet?.createdById:null,
      deletedOn:selectedWallet?.deletedOn ?selectedWallet?.deletedOn:null,
      deletedById:selectedWallet?.deletedById ?selectedWallet?.deletedById :null
    };

    if (edit) {
      // console.log("body",driverScheme)
      // console.log("body",body)
      body["id"] = selectedWallet?.id;
      updateWallet(body)
        .then((resp) => {
          showAlert("success", "Updated successfully");
          triggerRefresh();
          setEdit(false);
          setIsSearch(true);
          setTabValue(0);
        })
        .catch((err) => {
          showAlert("error", "Something went wrong");
        });
    } else {
      createWallet(body)
        .then((resp) => {
          showAlert("success", "Created successfully");
          setTabValue(0);
          setIsSearch(true);
          triggerRefresh();
        })
        .catch((err) => {
          showAlert("error", "Something went wrong");
        });
    }
  };

  return (
    <div>
      {isSearch ? (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <div
          style={{
            display: "flex",
            flexDirection:"column",
            alignItems: "center",
            justifyContent: "center",
          }}>
            <div
              style={{
                width: "400px",
                display: "flex",
                flexDirection: "column",
                gap: "20px",
              }}
            >
              <Button
                sx={{
                  width: "100%",
                  fontSize: "1rem",
                  color: "#41CC7D",
                  borderColor: "#41CC7D",
                  "&:hover": {
                    borderColor: "#41CC7D",
                  },
                }}
                variant="outlined"
                startIcon={<AddBoxIcon sx={{ color: "#41CC7D" }} />}
                onClick={() => {
                  handleNewClick();
                }}
              >
                New Wallet Minimum Balance
              </Button>

              <Select
                cacheOptions
                placeholder={"Search Wallet Minimum Balance"}
                onChange={(e) => {
                  handleExistClick(e);
                }}
                options={walletMinList}
                // loadOptions={getMinWalletOpt}
              />
            </div>
            <button
              type="button"
              className="btn submit-button margin-tp"
              onClick={() =>handleBack()}
            >
              Back
            </button>
          </div>
        </div>
      ) : (
        <Form onSubmit={handleSubmit(handleWalletMinBalSubmit)}>
          <Row>
            <FormGroup className="col-lg-4">
              <Label className="col-lg-12 col-form-label">Driver Scheme</Label>
              <Col lg="12">
                <input
                  value={driverScheme?.name}
                  className="form-control"
                  type="text"
                  {...register("DriverType", {
                    required: {
                      value: true,
                      message: "DriverType is required",
                    },
                  })}
                />
              </Col>
            </FormGroup>
            <FormGroup className="col-lg-4">
              <Label className="col-lg-12 col-form-label">Service City</Label>
              <Col lg="12">
                <Select
                  value={ServiceCity}
                  options={cityData}
                  {...register("ServiceCity", {
                    required: {
                      value: true,
                      message: "ServiceCity is required",
                    },
                  })}
                  placeholder={"Select Service City"}
                  onChange={(e) => setValue("ServiceCity", e)}
                  isDisabled={hasResolvedServiceCity}
                />
              </Col>
            </FormGroup>

            <FormGroup className="col-lg-4">
              <Label className="col-lg-12 col-form-label">
                Minimum Balance
              </Label>
              <Col lg="12">
                <input
                  value={minBalance}
                  className="form-control"
                  type="number"
                  {...register("minBalance", {
                    required: {
                      value: true,
                      message: "minBalance is required",
                    },
                    onChange: (e) => {
                      setValue("minBalance", e.target.value.trimStart());
                    },
                  })}
                />
                <span style={{ color: "red" }}>
                  {errors?.minBalance?.message}
                </span>
              </Col>
            </FormGroup>

            <FormGroup className="col-lg-6">
              <Label className="col-lg-12 col-form-label">
                Applicable From
              </Label>
              <Col lg="12">
                <InputGroup
                  className="date"
                  id="dt-minimum"
                  data-target-input="nearest"
                >
                  <DatePicker
                    className="form-control datetimepicker-input digits"
                    selected={applicableFromDateField.value}
                    showTimeSelect
                    showYearDropdown
                    showMonthDropdown
                    scrollableYearDropdown
                    onChange={handleApplicableFromDate}
                    dateFormat="MMMM d yyyy, h:mm:ss a"
                    onKeyDown={(e) => {
                      e.preventDefault();
                    }}
                  />
                </InputGroup>
                <span style={{ color: "red" }}>
                  {errors?.applicableFromDate?.message}
                </span>
              </Col>
            </FormGroup>

            <FormGroup className="col-lg-6">
              <Label className="col-lg-12 col-form-label">Applicable To</Label>
              <Col lg="12">
                <InputGroup
                  className="date"
                  id="dt-minimum"
                  data-target-input="nearest"
                >
                  <DatePicker
                    className="form-control datetimepicker-input digits"
                    selected={applicableToDateField.value}
                    showTimeSelect
                    showYearDropdown
                    showMonthDropdown
                    scrollableYearDropdown
                    onChange={handleApplicableToDate}
                    dateFormat="MMMM d yyyy, h:mm:ss a"
                    onKeyDown={(e) => {
                      e.preventDefault();
                    }}
                  />
                </InputGroup>
                <span style={{ color: "red" }}>
                  {errors?.applicableToDate?.message}
                </span>
              </Col>
            </FormGroup>
          </Row>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: "3rem",
              gap: "1rem",
            }}
          >
            <button
              type="button"
              className="btn submit-button"
              onClick={() => setIsSearch(true)}
            >
              Back
            </button>
            <button type="submit" className="btn submit-button">
              {edit ? "Update" : "Submit"}
            </button>
          </div>
        </Form>
      )}
    </div>
  );
}

export default WalletMinBal;
